import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import { fetchNavbarAndFooter } from "lib/fetchers/common";

import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";
import { SEO_SIFTED_ON_PINK_IMAGE } from "lib/constants/shared";
import ContactUsView from "content-ui/utilityPages/contact-us/ContactUs";
import { fetchContactUsPageData } from "content-ui/utilityPages/contact-us/fetcher";
import { ContactUsPageData } from "content-ui/utilityPages/contact-us/types";

export async function getStaticProps({ preview }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchContactUsPageData({ preview }),
  ]);

  return {
    props: {
      __initialState: {
        sitewideOption: { ...menuItems },
      },
      dato,
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every minute
    revalidate: 60,
  };
}

interface ContactUsPageProps {
  dato: ContactUsPageData;
}

const ContactUsPage = ({ dato }: ContactUsPageProps) => {
  const {
    seo: { description, title },
  } = dato;

  return (
    <>
      <Head>
        {generateNextSeo({
          canonical: buildCanonicalUrl("/contact-us"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: SEO_SIFTED_ON_PINK_IMAGE }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <ContactUsView data={dato} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default ContactUsPage;
